import moment from "moment";

export default {
    install(Vue) {
        Vue.mixin({
            methods: {
                $convertBoolean (bool) {
                    return bool ? 1 : 0
                },
                $hasPermission (permissions) {
                    let allowed = false
                    let currentRole = localStorage.getItem('ClientTypeID')
                    let find = permissions.filter(item => item === +currentRole)
                    if (find.length) {
                        allowed = true
                    } else {
                        allowed = false
                    }
                    return allowed
                },
                $showApprove (permissions) {
                    let allowed = false
                    let currentRole = localStorage.getItem('ClientTypeID')
                    let find = permissions.filter(item => item === +currentRole)
                    if (find.length) {
                        allowed = true
                    } else {
                        allowed = false
                    }
                    return allowed
                },
                $convertDate(date) {
                    moment.locale('en-ca');
                    return date ? moment(date).format('D MMM YY - hh:mm A') : ''
                }
            }
        })
    }
}
